import {
  AppstoreAddOutlined,
  FileOutlined,
  ProfileOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Permission, Resource } from "components/CurrentUser/constants";
import React from "react";
import { Redirect } from "react-router";
import { IRouteConfig } from "services/typings";
import { lazy } from "utils/route";

const routes: IRouteConfig[] = [
  {
    path: "/utilities",
    name: "utilities.title",
    icon: AppstoreAddOutlined,
    component: lazy(() => import("layouts/BlankLayout")),
    permissions: [
      [Resource.DEAL_MANAGE, Permission.CREATE],
      [Resource.DEAL_MANAGE, Permission.FULL_CREATE],
      [Resource.DEAL_MANAGE, Permission.UPDATE],
      [Resource.DEAL_MANAGE, Permission.FULL_UPDATE],
      [Resource.DEAL_MANAGE, Permission.VIEW],
      [Resource.DEAL_MANAGE, Permission.FULL_VIEW],
    ],
    routes: [
      {
        icon: ProfileOutlined,
        path: "/utilities/deals",
        name: "utilities.deals",
        component: lazy(() => import("./pages/Deals")),
        searchable: true,
        permissions: [
          [Resource.DEAL_MANAGE, Permission.CREATE],
          [Resource.DEAL_MANAGE, Permission.FULL_CREATE],
          [Resource.DEAL_MANAGE, Permission.UPDATE],
          [Resource.DEAL_MANAGE, Permission.FULL_UPDATE],
          [Resource.DEAL_MANAGE, Permission.VIEW],
          [Resource.DEAL_MANAGE, Permission.FULL_VIEW],
        ],
      },
      {
        path: "/utilities/lp-configuration",
        name: "utilities.landing_page_configuration",
        icon: SettingOutlined,
        component: lazy(() => import("layouts/BlankLayout")),
        searchable: true,
        permissions: [
          [Resource.DEAL_MANAGE, Permission.CREATE],
          [Resource.DEAL_MANAGE, Permission.FULL_CREATE],
          [Resource.DEAL_MANAGE, Permission.UPDATE],
          [Resource.DEAL_MANAGE, Permission.FULL_UPDATE],
          [Resource.DEAL_MANAGE, Permission.VIEW],
          [Resource.DEAL_MANAGE, Permission.FULL_VIEW],
        ],
        routes: [
          {
            path: "/utilities/lp-configuration",
            component: () => (
              <Redirect to="/utilities/lp-configuration/popular-brands" />
            ),
            exact: true,
            hideInMenu: true,
          },
          {
            path: "/utilities/lp-configuration/:tab",
            name: "utilities.landing_page_configuration",
            component: lazy(() => import("./pages/LandingPageConfiguration")),
            hideInMenu: true,
            searchable: true,
            permissions: [
              [Resource.DEAL_MANAGE, Permission.CREATE],
              [Resource.DEAL_MANAGE, Permission.FULL_CREATE],
              [Resource.DEAL_MANAGE, Permission.UPDATE],
              [Resource.DEAL_MANAGE, Permission.FULL_UPDATE],
              [Resource.DEAL_MANAGE, Permission.VIEW],
              [Resource.DEAL_MANAGE, Permission.FULL_VIEW],
            ],
          },
        ],
      },
    ],
  },
];

export default routes;
